
import Form from "./Form.vue";
import PosData from "./PosData";
import { mapGetters } from "vuex";

export default {
  name: "app-pos-create",
  data() {
    return {
      pos: new PosData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
